import ViewOrder from '../viewOrder';
import CancelOrder from '../cancelOrder';

const actions = {
  pendingValidation: [ViewOrder, CancelOrder],
  waitingOnCredit: [ViewOrder],
  waitingOnSales: [ViewOrder],
  contractSent: [ViewOrder],
  contractSigned: [ViewOrder],
  contractExpired: [ViewOrder],
  orderPlaced: [ViewOrder],
  orderCanceled: [ViewOrder],
  orderActivated: [ViewOrder],
  orderShipped: [ViewOrder],
  orderCompleted: [ViewOrder]
};

export default actions;
